// extracted by mini-css-extract-plugin
module.exports = {"quoteContainer":"testimonial-module--quote-container--1Po-W","quote":"testimonial-module--quote--3Rld2","quoteFooter":"testimonial-module--quote-footer--M3m3w"};